<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加机构管理员</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">


                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">登录账号</div>
                        <el-input v-model="add_loginName"    placeholder="请输入登录账号"  ></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">登录密码</div>
                        <el-input v-model="add_password"    placeholder="请输入登录密码" show-password  ></el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">姓名</div>
                        <el-input v-model="add_realName" placeholder="请输入姓名"  ></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">手机</div>
                        <el-input v-model="add_phone" maxlength="11"  placeholder="请输入手机"  ></el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">选择机构</div>
                        <el-select v-model="add_institutionCode"   placeholder="选择机构" @change="changeInstitution" style="width:100%">
                            <el-option
                                    v-for="item in institutionList"
                                    :key="item.institutionCode"
                                    :label="item.name"
                                    :value="item.institutionCode">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">选择角色</div>
                        <el-select v-model="add_roleCode" placeholder="选择角色" @change="changeRole" style="width:100%">
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.roleCode"
                                    :label="item.name"
                                    :value="item.roleCode">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Add",
        props: ['institutionList'],
        data() {
            return {

                loading: false,

                add_loginName:'',
                add_password:'',
                add_realName:'',
                add_phone:'',

                add_institutionCode:'',
                add_roleCode:'',

                // institutionList:null,
                roleList:null,
                // insAlways:true

            }
        },
        methods: {
            init(){
                console.log("Add init");

                this.add_loginName = '';
                this.add_password = '';
                this.add_realName = '';
                this.add_phone = '';

                this.add_institutionCode='';
                this.add_roleCode = '';

                // this.getInstitutionList();

            },
            closeSelf() {
                this.$emit("closeAdd");
            },

            confirm(){


                if(this.add_loginName == ''){
                    return;
                }
                if(this.add_password == ''){
                    return;
                }
                if(this.add_realName == ''){
                    return;
                }
                if(this.add_phone == ''){
                    return;
                }
                if(this.add_institutionCode == ''){
                    return;
                }
                if(this.add_roleCode == ''){
                    return;
                }


                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Staff/AddIns',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),

                        loginName: this.add_loginName,
                        password:this.add_password,
                        realName:this.add_realName,
                        phone:this.add_phone,

                        institutionCode:this.add_institutionCode,
                        roleCode:this.add_roleCode,

                    }

                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.$emit("closeAdd");
                        this.$emit("getList");
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },


            changeInstitution:function(selVal){
                this.add_institutionCode = selVal;
                let insAlways="机构管理员"
                this.institutionList.forEach(element => {
                    if(element.institutionCode==selVal && element.isChain ==1){
                        switch(element.chainType){
                            case 'parent':
                                insAlways="总机构管理员"
                                break;
                            case 'middle':
                                insAlways="区域经理"
                                break;
                            default:
                                break;
                        }
                    }
                });
                this.getRoleList(selVal,insAlways);
            },

            // getInstitutionList(){
            //     this.$axios({
            //         method: 'post',
            //         url: this.$institutionUrl+'Institution/List',
            //         data: {
            //             timeStr:timeStr,
            //             sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            //             staffCode: getStaffCode(),
            //         }
            //     }).then((response)=> {
            //         console.log(response.data);
            //         if(response.data.error == 0){
            //             this.institutionList = response.data.data.listInstitution;
            //         }else if(response.data.error == 1){
            //             this.$message(response.data.message);
            //         }else{
            //             console.log(response.data.message);
            //         }
            //     }).catch(function (error) {
            //         console.log(error);
            //     });
            // },


            changeRole:function(selVal){
                this.add_roleCode = selVal;
            },

            getRoleList(selVal,roleName){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'RoleInstitution/ListForAdmin',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        institutionCode:selVal
                    }
                }).then((response)=> {
                    if(response.data.error == 0){
                        var roleList=response.data.data.listRoleDTO;
                        this.add_roleCode=''
                        roleList.forEach(element => {
                            if(element.name==roleName){
                                this.add_roleCode = element.roleCode
                            }
                        });
                        this.roleList =roleList
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },


        }
    }
</script>

<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .modal {
        background-color: #fff;
        box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 500px;
    }
    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
    }
    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }






</style>
